import script from "./TaggedImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaggedImage.vue?vue&type=script&setup=true&lang=ts"

import "./TaggedImage.vue?vue&type=style&index=0&id=1cb93adc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cb93adc"]])

export default __exports__